import React from 'react';

export const FUELS = [
  { key: 'e5', label: 'Super E5' },
  { key: 'e10', label: 'Super E10' },
  { key: 'diesel', label: 'Diesel' },
];

export const fmtPrice = (p) =>
  typeof p === 'number' ? `${p.toFixed(3).replace('.', ',')} €` : '—';

export const fmtCent = (p) =>
  typeof p === 'number' ? `${Math.round(p * 100)} ct` : '—';

/** Kraftstoff-Umschalter (Pills) */
export function FuelTabs({ fuel, onChange }) {
  return (
    <div className="inline-flex rounded-full border border-stone-200 bg-white p-1" role="tablist" data-testid="fuel-tabs">
      {FUELS.map((f) => (
        <button
          key={f.key}
          role="tab"
          aria-selected={fuel === f.key}
          onClick={() => onChange(f.key)}
          data-testid={`fuel-tab-${f.key}`}
          className={`px-4 py-1.5 rounded-full text-[13px] font-medium transition-colors ${
            fuel === f.key ? 'bg-stone-900 text-white' : 'text-stone-500 hover:text-stone-900'
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}

/** Tankstellen-Liste, sortiert nach gewähltem Kraftstoff (günstigste zuerst) */
export function StationList({ stations, fuel, limit = 15, testIdPrefix = 'station' }) {
  const sorted = [...stations].sort((a, b) => {
    const va = typeof a[fuel] === 'number' ? a[fuel] : Infinity;
    const vb = typeof b[fuel] === 'number' ? b[fuel] : Infinity;
    return va - vb;
  });
  const shown = sorted.slice(0, limit);
  const cheapest = shown.length && typeof shown[0][fuel] === 'number' ? shown[0][fuel] : null;

  return (
    <div className="divide-y divide-stone-100 rounded-2xl border border-stone-200 bg-white overflow-hidden" data-testid={`${testIdPrefix}-list`}>
      {shown.map((s, i) => (
        <div key={s.id || i} className="flex items-center gap-4 px-4 sm:px-5 py-3.5" data-testid={`${testIdPrefix}-row-${i}`}>
          <span className="w-6 shrink-0 text-[13px] tabular-nums text-stone-400">{i + 1}.</span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <p className="truncate text-[14px] font-semibold text-stone-900">{s.brand || s.name || 'Freie Tankstelle'}</p>
              {s.is_open ? (
                <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">Geöffnet</span>
              ) : (
                <span className="shrink-0 rounded-full bg-stone-100 px-2 py-0.5 text-[10px] font-medium text-stone-500">Geschlossen</span>
              )}
            </div>
            <p className="truncate text-[12px] text-stone-500">
              {s.street} {s.house_number}{s.postcode ? ` · ${s.postcode} ${s.city}` : ''}
              {typeof s.dist === 'number' ? ` · ${s.dist.toFixed(1)} km` : ''}
            </p>
          </div>
          <div className="hidden sm:flex flex-col items-end gap-0.5 text-[11px] text-stone-400 tabular-nums">
            {FUELS.filter((f) => f.key !== fuel).map((f) => (
              <span key={f.key}>{f.label}: {fmtPrice(s[f.key])}</span>
            ))}
          </div>
          <p className={`w-24 shrink-0 text-right text-[16px] font-semibold tabular-nums ${
            cheapest !== null && s[fuel] === cheapest ? 'text-emerald-600' : 'text-stone-900'
          }`}>
            {fmtPrice(s[fuel])}
          </p>
        </div>
      ))}
      {!shown.length && (
        <p className="px-5 py-8 text-center text-sm text-stone-400" data-testid={`${testIdPrefix}-empty`}>
          Keine Tankstellen mit Preisdaten gefunden.
        </p>
      )}
    </div>
  );
}

/** MTS-K / Tankerkönig Pflicht-Attribution */
export function DataAttribution({ fetchedAt }) {
  return (
    <p className="text-[11px] text-stone-400" data-testid="data-attribution">
      Preisdaten: <a href="https://creativecommons.tankerkoenig.de" target="_blank" rel="noopener noreferrer" className="underline hover:text-stone-600">Tankerkönig.de</a> / Markttransparenzstelle für Kraftstoffe (MTS-K), Lizenz CC BY 4.0
      {fetchedAt ? ` · Stand: ${new Date(fetchedAt).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })} Uhr` : ''} · Alle Angaben ohne Gewähr
    </p>
  );
}
